// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Cc51","field":"styles_field__1XE8p","fieldCol":"styles_fieldCol___umco","diffCol":"styles_diffCol__V187t","diff":"styles_diff__34SJq"};